export default [
  {
    path: "domains",
    name: "domains",
    component: (): Promise<any> => import(/* webpackChunkName: "domains" */ "@/views/Admin/DomainsView.vue")
  }
];
